<script setup>
const emit = defineEmits(["click"]);
const props = defineProps({
  disable: [Boolean, Number],
  selected: [Boolean, Number],
});

const classMap = computed(() => ({
  "nio-radio-v2--selected": props.selected,
  "nio-radio-v2--disable": props.disable,
}));

const handleClick = () => {
  if (props.disable) return;
  emit("click");
};
</script>

<template>
  <div class="nio-radio-v2" :class="classMap" @click.stop="handleClick" />
</template>

<style lang="scss" scoped>
.nio-radio-v2 {
  @include transition;
  width: rem(16);
  height: rem(16);
  border-radius: 100%;
  border: rem(1) solid #999dae;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    border-color: #8d95a9;
  }
}

.nio-radio-v2--selected {
  border-width: rem(4);
  border-color: #00bebe;

  &:hover {
    border-color: #00bebe;
  }
}

.nio-radio-v2--disable {
  border-color: #d5d8e0;
  background: #f6f7f9;
  cursor: not-allowed;

  &:hover {
    border-color: #d5d8e0;
  }
}
</style>
